import mixpanelLib from "mixpanel-browser";

// Safe Mixpanel facade. mixpanel-browser >= 2.80 crashes on track()/identify()/reset()
// when init() never ran — which happens when VITE_TRACKING_KEY is not configured
// (init(token) is a silent no-op for a falsy token). This facade no-ops all calls
// until init() succeeds, so a missing tracking key degrades gracefully instead of
// throwing across the app.
//
// To enable real tracking, set VITE_TRACKING_KEY in the frontend environment.

let configured = false;

const mixpanel = {
  init(token, config) {
    if (!token) {
      console.warn("VITE_TRACKING_KEY not set — Mixpanel tracking disabled.");
      return;
    }
    configured = true;
    mixpanelLib.init(token, config);
  },
  track(name, props) {
    if (!configured) return;
    mixpanelLib.track(name, props);
  },
  identify(id) {
    if (!configured) return;
    mixpanelLib.identify(id);
  },
  reset() {
    if (!configured) return;
    mixpanelLib.reset();
  },
};

export default mixpanel;
